export { default as PromoScootComp } from './PromoScootComp';
export { default as PromoHotelComp } from './PromoHotelComp';
export { default as PromoIjtoComp } from './PromoIjtoComp';
export { default as PromoIjtoEnComp } from './PromoIjtoEnComp';
export { default as MPromoScootComp } from './MPromoScootComp';
export { default as MPromoHotelComp } from './MPromoHotelComp';
export { default as MPromoIjtoComp } from './MPromoIjtoComp';
export { default as MPromoIjtoEnComp } from './MPromoIjtoEnComp';
export { default as MPromoTwITFComp } from './MPromoTwITFComp';